import { Component, OnInit } from '@angular/core';
import { DataService } from '../services/data.service';

@Component({
  selector: 'app-outbred-analysis',
  templateUrl: './outbred-analysis.component.html',
  styleUrls: ['./outbred-analysis.component.css']
})
export class OutbredAnalysisComponent implements OnInit {
  dataSource: string = "tyx";
  analysisType: string;
  samples: any[] = [];
  selectedSamples: any[] = [];
  stocks: any[] = [];
  selectedStock: any;
  selectedStrains: any[] = [];
  locations: any[] = [];
  selectedLocation: any;
  selectedLocations: any[] = [];
  showStats: boolean = false;

  constructor(private dataService: DataService) { }

  ngOnInit() {
    //this.samples.push({name: "All", id: 1});
    //this.samples.push({name: "Sample2-Strain2-Loc1", id: 2});
    //this.samples.push({name: "Sample3-Strain1-Loc2", id: 3});
    //this.samples.push({name: "Sample4-Strain2-Loc2", id: 4});

    //this.strains.push({name: "Strain2", id: 2});

    //this.locations.push({name: "Loc1", id: 1});
    //this.locations.push({name: "Loc2", id: 2});
    this.populateLocations();
    this.selectedLocation = 0;
    this.populateStocks();
    this.selectedStock = 0;
    this.setChartOptions();
    this.buildGraph();
  }

  setChartOptions(){
    this.options = {
      scales: {
        x: [{
          type: 'time',
          time: {
            unit: 'day',
            displayFormats: {
              day: 'YYYY-MM-DD'
            }
          }
        }]
      }
    }
  }

  //Maybe used for minimuga data
  PopulateData(event: any){
    this.showStats = true;
  }

  //new data
  chart: any;
  graphData: any;
  chartData: any;
  options: any;
  checked: boolean = true;
  showSpinner: boolean = true;
  loading: boolean = true;
  first: boolean = true;
  probeNames: any[];
  sampleNames: any[];
  allRecords: any[][];
  showDetails: boolean = false;

  buildLineChart(){
    this.graphData = {
      labels: this.chartData.dates,
      datasets: this.chartData.outbredSubGroups.map((s: { objectName: any; percents: any; }) => ({label: s.objectName, data: s.percents}))
    }
  }

  buildGraph(){
    if (this.selectedStock == null)
      this.selectedStock = 0;
    if (this.selectedLocation == null)
      this.selectedLocation = 0;

    this.showSpinner = true;
    this.first = false;
    //this.dataService.getLocationGraphs(this.selectedStrain.key, this.selectedLocation.key).then(data => {
    this.dataService.getOutbredPage(this.selectedStock, this.selectedLocation).then(data => {
      this.chartData = data.graph;
      this.sampleNames = data.sampleNames;
      this.probeNames = data.probeNames;
      this.allRecords = data.snpRecords;
      this.buildLineChart();
      this.showSpinner = false;
    });
  }

  populateLocations(){
    this.locations = [];
    this.locations.push({key: 0, value: "All"});
    this.dataService.getLocations().then(data => {
      data.map((x: any) => this.locations.push({key: x.locationId, value: x.name}))
      //this.selectedLocation = this.locations[0];
    });
  }

  populateStocks(){
    this.stocks = [];
    this.stocks.push({key: 0, value: "All"});
    this.dataService.getStocks().then(data => {
      data.map((x: any) => this.stocks.push({key: x.stockId, value: x.name}))
      //this.selectedStock = this.stocks[0];
    });
  }

  locationChange(){
    this.sampleNames = [];
    this.probeNames = [];
    this.showDetails = false;
    this.buildGraph();
  }

  stockChange(){
    this.sampleNames = [];
    this.probeNames = [];
    this.showDetails = false;
    this.buildGraph();
  }

  deselectAll(){
    this.buildLineChart();
    this.graphData.datasets.forEach(function(ds:any) {
      ds.hidden = true;
    });
  }

  selectAll(){
    this.buildLineChart();
    this.graphData.datasets.forEach(function(ds:any) {
      ds.hidden = false;
    });
  }

  getSampleName(sampleName: string){
    if (sampleName == "header")
      return "_";
    else
      return sampleName;
  }

  getSampleProbeResult(sampleName: string, probeName: string, index: number){
    if (sampleName == "header")
      return probeName;

    if (probeName == "_")
      return sampleName;

    var samples = this.allRecords[index].filter(function (v: any, i: any) {
      return (v["probeName"] == probeName && v["sampleName"] == sampleName);
    });

    if (samples != undefined && samples != null && samples.length > 0)
      return samples[0].result;
    else
      return "N/A";
  }
}
